import React from 'react'

import {ActionButtonWidget} from './ActionButton'
import {AddressWidget} from './Address'
import {DividerWidget} from './Divider'
import {FormWidget} from './Form'
import {HeaderWidget} from './Header'
import {IconButtonWidget} from './IconButton'
import {IconSpotWidget} from './IconSpot'
import {ImageWidget} from './Image'
import {NavWidget} from './Nav'
import {PaymentMethod} from './PaymentMethod'
import {RadioWidget} from './Radio'
import {SegmentWidget} from './Segment'
import {SlotWidget} from './Slot'
import {SwitchWidget} from './Switch'
import {TagLineWidget} from './TagLine'
import {TextWidget} from './Text'
import {WidgetConfig, WidgetProps, WidgetPropsByType, WidgetType} from './types'

export const mapTypeToWidget: {[key in WidgetType]: React.FC<WidgetPropsByType<key>>} = {
  [WidgetType.ACTION_BUTTON]: ActionButtonWidget,
  [WidgetType.ADDRESS]: AddressWidget,
  [WidgetType.DIVIDER]: DividerWidget,
  [WidgetType.FORM]: FormWidget,
  [WidgetType.HEADER]: HeaderWidget,
  [WidgetType.ICON_BUTTON]: IconButtonWidget,
  [WidgetType.ICON_SPOT]: IconSpotWidget,
  [WidgetType.NAV]: NavWidget,
  [WidgetType.PAYMENT_METHOD]: PaymentMethod,
  [WidgetType.IMAGE]: ImageWidget,
  [WidgetType.RADIO]: RadioWidget,
  [WidgetType.SEGMENT]: SegmentWidget,
  [WidgetType.SLOT]: SlotWidget,
  [WidgetType.SWITCH]: SwitchWidget,
  [WidgetType.TAG_LINE]: TagLineWidget,
  [WidgetType.TEXT]: TextWidget,
}

export const renderWidget = <T extends WidgetConfig>(externalProps: T): React.ReactElement | null => {
  // TS не смог понять, что к конкретному *типу* виджета относится конкретный *конфиг* виджета,
  // из-за чего приходится применять явное приведение типов
  const Component = mapTypeToWidget[externalProps.type] as React.FC<WidgetProps>
  const props: WidgetProps = 'key' in externalProps ? {...externalProps, name: externalProps.key} : externalProps

  if (!Component) {
    // TODO: Выкидывать ошибку после завершения разработки виджетов
    // throw new Error(`Виджет ${props.type} не найден`)
    return null
  }

  return <Component {...props} />
}
